import React from 'react';

/**
 * Phone off icon component
 * Displays phone with slash to indicate end call/disconnect action
 */
const PhoneOffIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="16" 
    height="16" 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M3.4613 8.54033C2.33854 6.80899 1.63754 4.83844 1.41464 2.78699C1.39798 2.60264 1.41989 2.41683 1.47897 2.24141C1.53805 2.06598 1.63302 1.90478 1.75781 1.76807C1.88261 1.63136 2.03451 1.52213 2.20383 1.44734C2.37315 1.37255 2.5562 1.33383 2.7413 1.33366H4.7413C5.06484 1.33047 5.3785 1.44504 5.62381 1.65601C5.86912 1.86698 6.02935 2.15996 6.07463 2.48033C6.15905 3.12037 6.3156 3.74881 6.5413 4.35366C6.631 4.59227 6.65041 4.8516 6.59724 5.10091C6.54407 5.35022 6.42054 5.57907 6.2413 5.76033L5.39464 6.60699M15.3346 0.666992L0.667969 15.3337M7.1213 8.87366C7.79787 9.55082 8.56251 10.1338 9.39463 10.607L10.2413 9.76033C10.4226 9.58108 10.6514 9.45756 10.9007 9.40439C11.15 9.35122 11.4094 9.37063 11.648 9.46032C12.2528 9.68603 12.8813 9.84258 13.5213 9.92699C13.8417 9.97227 14.1346 10.1325 14.3456 10.3778C14.5566 10.6231 14.6712 10.9368 14.668 11.2603V13.2603C14.6687 13.446 14.6307 13.6298 14.5563 13.7999C14.4819 13.97 14.3728 14.1227 14.236 14.2482C14.0992 14.3738 13.9377 14.4693 13.7618 14.5288C13.5859 14.5883 13.3995 14.6104 13.2146 14.5937C11.1632 14.3708 9.19263 13.6698 7.4613 12.547C6.65815 12.037 5.91365 11.4401 5.2413 10.767L7.1213 8.87366Z" 
      stroke="currentColor" 
      strokeWidth="1.6" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default PhoneOffIcon;
